 <script>
  import Tournaments from 'src/pc/pages/Tournaments'
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  export default {
    extends: Tournaments,
    components: {
      PageLayout,
      SubPageLayout,
      DisplayContainer
    },
    computed: {
      getAccess () {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .search_tnmt {
    top: 0 !important;
  }
  .search_tnmt .display-container.title {
    width: 100vw;
    margin-bottom: 30px;
  }
  .search_tnmt .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .search_tnmt .title_top:before {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .search_tnmt .title_top p {
    font-size: 34px;
  }
  .search_tnmt .searchbox {
    padding: 5px 15px;
    background: #fff;
    width: 100vw;
    margin-left: -15px;
    margin-top: -30px;
  }
  .search_tnmt .searchbox ul {
    border-bottom: 0;
  }
  .search_tnmt .searchbox li {
    font-size: 14px;
    font-weight: 800;
    padding: 5px 0;
    display: flex;
    align-items: center;
    line-height: 1.0em;
    border-bottom: 1px solid #ddd;
    height: 50px;
  }
  .search_tnmt .searchbox li:last-child {
    border-bottom: 0;
  }
  .search_tnmt .searchbox li p {
    width: 18%;
    padding: 0;
    font-size: 13px;
  }
  .search_tnmt .searchbox li:last-child {
    height: 50px;
  }
  .search_tnmt .searchbox li:last-child p {
    display: none
  }
  .search_tnmt .searchbox li p span {
    display: block;
  }
  .search_tnmt .searchbox .reset {
    padding: 8px 10px 8px 20px;
    font-size: 13px;
    color: #777;
    right: 25px;
  }
  .search_tnmt .searchbox .reset:before {
    width: 12px;
    height: 14px;
    position: relative;
  }
  .search_tnmt .searchbox .reset.rst-mo {
    padding: 0;
    font-size: 0;
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e5e5e5;
    border-radius: 100%;
  }
  .search_tnmt .el-select {
    width: 28%;
  }
  .search_tnmt .el-select.sel-region, .search_tnmt .el-select.sel-brand {
    width: 82%;
  }
  .search_tnmt .el-select.sel-month {
    width: 20%;
  }
  .search_tnmt .el-input__inner {
    font-size: 14px;
    border-bottom: 0;
    background: #fff;
  }
  .search_tnmt .el-icon-arrow-up:before {
    width: 9px;
    height: 9px;
    transform: rotate(180deg) translate(0,-160%);
  }
  .search_tnmt .el-checkbox {
    margin-left: 4.0vw;
    margin-right: 1.5vw;
  }
  .search_tnmt .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }
  .search_tnmt .el-checkbox__inner {
    width: 15px;
    height: 15px;
  }
  .search_tnmt .el-checkbox__inner:after {
    height: 6px;
    width: 3px;
    left: 4px;
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
  }
  .search_tnmt .searchbox li:nth-child(3) div:nth-child(4) p {
    text-align: center;
    line-height: 1.0em;
  }
  .search_tnmt .searchbox li .option {
    font-size: 14px;
    padding: 12px 18px;
    margin: 0 2px;
  }
  .search_tnmt .searchbox li .option.on {
    color: #fff;
    background: #00c74e;
  }
  .search_tnmt .searchbox li .option.on:hover {
    background: #00c74e;
  }
  .search_tnmt .searchbox li:nth-child(2) .option:nth-child(3).on {
    background: #368ee9;
  }
  .search_tnmt .searchbox li .option:hover {
    background: #ddd;
  }
  .search_tnmt .searchbox li .for_mo {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eee;
  }
  .search_tnmt .searchbox li a {
    display: inline-block;
  }
  .search_tnmt .searchbox li .btn_sch {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background: #000;
    padding: 16px 20vw;
    border-radius: 4px;
  }
  .search_tnmt .searchbox li .btn_sch:hover {
    color: #00ff64;
  }
  .search_tnmt .searchbox li .btn_reset {
    font-size: 12px;
    color: #000;
    padding: 15px 20px;
    border-radius: 4px;
    margin-left: 5px;
  }
  .search_tnmt .searchbox li .btn_reset:hover {

  }
  .search_tnmt select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: inherit;
    font-weight: 600;
    color: #000;
    border: 1px solid #aaa;
    padding: 11px 50px 11px 10px;
    background-size: 14px 12px;
    background-position: right 12px top 50%;
  }
  .search_tnmt select#brand {
    max-width: 77vw;
  }
  .search_tnmt select:hover {
    border: 1px solid #aaa;
  }
  .search_tnmt select::-ms-expand {
    display: none;
  }
  .search_tnmt select option {
    padding: 10px;
  }
  .search_tnmt .info_wrap {
    margin: 10px 0 0 0;
  }
  .search_tnmt .info_wrap .info {
    padding: 10px;
    position: relative;
  }
  .search_tnmt .info_wrap .info p {
    font-size: 12.5px;
    line-height: 1.4em;
    padding-left: 20px;
  }
  .search_tnmt .info_wrap .info p span {
    display: block;
  }
  .search_tnmt .info_wrap .info p:before {
    position: absolute;
    top: 1.1em;
    left: 10px;
    font-size: 0.8em;
    width: 14px;
    height: 14px;
  }
  .search_tnmt .list {
    margin-top: 40px;
  }
  .search_tnmt .list h3 {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.0em;
    letter-spacing: -0.02em;
    margin-bottom: 14px;
  }
  .search_tnmt .list .btn_view {
    float: right;
    font-size: 13px;
    font-weight: 500;
    padding: 0 0 0 18px;
    border: 0;
    margin: 0;
  }
  .search_tnmt .list .btn_view:hover {
    border: 0;
  }
  .search_tnmt .list .btn_view:after {
    left: 0;
    font-size: 14px;
    font-weight: 700;
  }
  .search_tnmt .list ul {
    font-size: 13px;
    font-weight: 500;
    padding: 10px 0;
  }
  .search_tnmt .list ul.th {
    min-height: 50px;
    height: 50px;
  }
  .search_tnmt .list ul.tr {
    height: unset;
    min-height: 60px;
  }
  .search_tnmt .list ul.tr:hover {
    color: unset;
    border: 1px solid transparent;
    box-shadow: none;
    background: #fff;
  }
  .search_tnmt .list ul.th li span i {
    right: -13px;
    transform: translate(0, -25%);
  }
  .search_tnmt .list ul.th li .up:after {
    border-bottom: 3px solid rgba(0,255,100,1.0);
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
  .search_tnmt .list ul.th li .down:after {
    border-top: 3px solid rgba(0,255,100,1.0);
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
  }
  .search_tnmt .list li {
    line-height: 1.15em;
  }
  .search_tnmt .list li span {
    margin-right: 5px;
  }
  .search_tnmt .list li span:last-child {
    margin-right: 0;
  }
  .search_tnmt .list li p.event {
    display: block;
  }
  .search_tnmt .list li .flag {
    margin-right: 0;
  }
  .search_tnmt .list li .ongo {
    font-size: 10px;
    margin-left: 0;
    margin-top: 3px;
  }
  .search_tnmt .list li .live {
    margin-left: 0;
    margin-top: 3px;
    height: 16px;
  }
  .search_tnmt .list li .live.news {
    margin-left: 2px;
  }
  .search_tnmt .list ul.th li:nth-child(1) {
    width: 16%;
  }
  .search_tnmt .list ul.th li:nth-child(2) {
    width: 15%;
  }
  .search_tnmt .list ul.th li:nth-child(3) {
    width: 15%;
  }
  .search_tnmt .list ul.th li:nth-child(4) {
    width: 54%;
  }
  .search_tnmt .list ul.tr li:nth-child(1) {
    display: none;
  }
  .search_tnmt .list ul.tr li:nth-child(2) {
    display: none;
  }
  .search_tnmt .list ul.tr li:nth-child(3) {
    width: 16%;
    padding: 0;
    text-align: center;
  }
  .search_tnmt .list ul.tr li:nth-child(4) {
    width: 15%;
  }
  .search_tnmt .list ul.tr li:nth-child(5) {
    width: 15%;
  }
  .search_tnmt .list ul.tr li:nth-child(6) {
    width: 54%;
    padding-left: 10px;
    padding-right: 15px;
  }
  /*.search_tnmt .list ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px;
    min-height: unset;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.02em;
    border: 1px solid #ccc;
    margin-bottom: 7px;
  }
  .search_tnmt .list ul:after {
    content: "View Details";
    display: block;
    width: 100%;
    height: 45px;
    background: #00c74e;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    line-height: 45px;
    text-align: center;
    margin-top: 10px;
  }
  .search_tnmt .list ul:nth-child(odd) {
    background: #fff;
  }
  .search_tnmt .list ul:nth-child(even) {
    background: #fff;
  }
  .search_tnmt .list ul.th {
    display: none;
  }
  .search_tnmt .list ul.tr:hover {
    color: unset;
    border: 1px solid #ccc;
    box-shadow: none;
  }
  .search_tnmt .list li {
    text-align: left;
    margin: 8px 0;
    flex-basis: 50%;
    font-weight: 600;
  }
  .search_tnmt .list li:nth-child(1),
  .search_tnmt .list li:nth-child(2),
  .search_tnmt .list li:nth-child(3),
  .search_tnmt .list li:nth-child(4),
  .search_tnmt .list li:nth-child(5),
  .search_tnmt .list li:nth-child(6),
  .search_tnmt .list li:nth-child(7),
  .search_tnmt .list li:nth-child(8),
  .search_tnmt .list li:nth-child(9) {
    width: unset;
  }
  .search_tnmt .list li:nth-child(3),
  .search_tnmt .list li:nth-child(7) {
    display: none;
  }
  .search_tnmt .list li:before {
    content: "";
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: #00c74e;
    line-height: 1.0em;
    margin-bottom: 8px;
  }
  .search_tnmt .list li:nth-child(1):before {
    content: "Date";
  }
  .search_tnmt .list li:nth-child(2):before {
    content: "Country";
  }
  .search_tnmt .list li:nth-child(5):before {
    content: "Prize Pool";
  }
  .search_tnmt .list li:nth-child(6):before {
    content: "Events";
  }
  .search_tnmt .list li:nth-child(4) {
    font-size: 17px;
    font-weight: 800;
    order: -1;
    flex-basis: 100%;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
    margin: 0 0 10px;
  }
  .search_tnmt .list li:nth-child(4) p {
    max-height: inherit;
    -webkit-line-clamp: 3;
  }
  .search_tnmt .list li:nth-child(4):before {
    display: none;
  }*/

  /* 이벤트 상세 */
  .search_tnmt .list.event ul:after {
    background: #368ee9;
  }
  .search_tnmt .list.event li {
    font-weight: 600;
  }
  .search_tnmt .list.event li:nth-child(1) {
    flex-basis: 30%;
    font-weight: 800;
    color: #00c74e;
    margin: 10px 0 20px;
  }
  .search_tnmt .list.event li:nth-child(2) {
    flex-basis: 25%;
    margin: 10px 0 20px;
  }
  .search_tnmt .list.event li:nth-child(3) {
    display: block;
    flex-basis: 100%;
    order: -2;
    font-weight: 800;
    color: #368ee9;
    margin-top: 0;
  }
  .search_tnmt .list.event li:nth-child(4) {
    flex-basis: 100%;
    border-bottom: 0;
    font-size: 17px;
    font-weight: 800;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  .search_tnmt .list.event li:nth-child(5) {
    flex-basis: 45%;
    margin: 10px 0 20px;
  }
  .search_tnmt .list.event li:nth-child(6) {
    flex-basis: 55%;
  }
  .search_tnmt .list.event li:nth-child(7) {
    display: block;
    flex-basis: 25%;
  }
  .search_tnmt .list.event li:nth-child(7):after {
    content: "";
    position: absolute;
    margin-top: -37px;
    left: 20px;
    right: 20px;
    border-bottom: 1px solid #eee;
  }
  .search_tnmt .list.event li:nth-child(8) {
    flex-basis: 20%;
  }
  .search_tnmt .list.event li:nth-child(9) {
    display: none;
  }
  .search_tnmt .list.event li:before {
    font-size: 13px;
    font-weight: 500;
    color: #999;
  }
  .search_tnmt .list.event li:nth-child(1):before {
    display: none;
  }
  .search_tnmt .list.event li:nth-child(2):before {
    display: none;
  }
  .search_tnmt .list.event li:nth-child(3):before {
    display: none;
  }
  .search_tnmt .list.event li:nth-child(5):before {
    content: "Buy-In";
    display: inline-block;
    margin: 3px 7px 0 0;
  }
  .search_tnmt .list.event li:nth-child(6):before {
    content: "Prize Pool";
  }
  .search_tnmt .list.event li:nth-child(7):before {
    content: "Entry";
  }
  .search_tnmt .list.event li:nth-child(8):before {
    content: "Level";
  }

  .search_tnmt .list .ad_list a {
    padding: 35px 0;
    border-radius: 8px;
  }
  .search_tnmt .list .ad_list a img {
    width: 300px !important;
    height: auto !important;
  }
  .search_tnmt .list .compact .ad_list a {
    padding: 15px 0;
    border: 0;
    margin-bottom: 0;
  }
  .search_tnmt .list .tnmt_ctnr {
    display: inherit;
    padding: 46.25vw 15px 18px 15px;
		border: 1px solid #e3e3e3;
  }
  .search_tnmt .list .tnmt_ctnr:hover {
    border: 1px solid #e3e3e3;
  }
	.search_tnmt .list .tnmt_ctnr .brand {
		position: absolute;
    top: 27vw;
    left: 15px;
    width: 16vw;
    height: 16vw;
    z-index: 1;
  }
	.search_tnmt .list .tnmt_ctnr .brand .img,
	.search_tnmt .list .tnmt_ctnr .brand .img img {
    width: 100%;
		height: 100%;
    border-radius: 5px;
  }
	.search_tnmt .list .tnmt_ctnr .brand .img:after {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  .search_tnmt .list .tnmt_ctnr .venue {
		position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 40vw;
  }
  .search_tnmt .list .tnmt_ctnr .venue .img {
		width: 100%;
    height: 100%;
    object-fit: cover;
  }
	.search_tnmt .list .tnmt_ctnr .cont {
    width: 100%;
		padding: 0;
  }
	.search_tnmt .list .tnmt_ctnr .cont h5 {
    line-height: 1.0em;
    width: 100%;
  }
	.search_tnmt .list .tnmt_ctnr .cont h5 p {
    font-size: 18px;
		font-weight: 700;
    line-height: 1.2em;
    margin-right: 0;
  }
	.search_tnmt .list .tnmt_ctnr .cont h5 .ongo {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 11px;
    padding: 5px 8px;
  }
	.search_tnmt .list .tnmt_ctnr .cont .loc {
    font-size: 14px;
		font-weight: 500;
		color: #000;
		padding: 6px 0 15px 0;
    line-height: 1.0em;
  }
	.search_tnmt .list .tnmt_ctnr .cont .loc .flag {
    width: 16px;
    height: 12px;
    margin-right: 8px;
  }
	.search_tnmt .list .tnmt_ctnr .cont p.date {
    font-size: 15px;
  }
	.search_tnmt .list .tnmt_ctnr .cont p.date:before {
    display: none;
  }
	.search_tnmt .list .tnmt_ctnr .etc {
    width: 20%;
    margin-top: 10px;
    position: absolute;
    right: 15px;
    bottom: 18px;
  }
	.search_tnmt .list .tnmt_ctnr .etc span {
    height: 18px;
    margin: 8px 0 0;
  }
	.search_tnmt .list .tnmt_ctnr .etc span.flag {
    width: 24px;
  }
	.search_tnmt .list .tnmt_ctnr .btn {
		position: relative;
		margin-top: 15px;
		left: 0;
    right: 0;
		bottom: unset;
		font-size: 16px;
		font-weight: 800;
		text-align: center;
		padding: 0;
		width: 100%;
		height: 45px;
		line-height: 45px;
		background: #00bb49;
  }
	.search_tnmt .list .tnmt_ctnr .btn:after {
    right: 15px;
  }
	.search_tnmt .list .no-results {
    padding: 60px 0;
  }
	.search_tnmt .list .no-results p {
    font-size: 16.5px;
  }
	.search_tnmt .list .no-results .reset {
    font-size: 15px;
    margin-top: 20px;
  }
	.search_tnmt .list .no-results .reset:before {
    width: 12px;
    height: 20px;
  }

  .search_tnmt .pager {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 600;
  }
  .search_tnmt .pager a {
    cursor: pointer;
    line-height: 2.0em;
    transition: .15s;
  }
  .search_tnmt .pager a.prev:before {
    width: 12px;
    height: 14px;
    margin-right: 12px;
    margin-top: 7px;
  }
  .search_tnmt .pager a.next:after {
    width: 12px;
    height: 14px;
    margin-left: 12px;
    margin-top: 7px;
  }
  .search_tnmt .pager span {
    margin: 0 22px;
  }
  .search_tnmt .pager span img {
    width: 25px;
  }
  .m-hide {
    display: none !important;
  }
  .list li span.p-hide {
    display: inline-block !important;
  }
</style>
